import { render, staticRenderFns } from "./AppendixLiquid.vue?vue&type=template&id=2690ab9b&scoped=true"
import script from "./AppendixLiquid.vue?vue&type=script&lang=js"
export * from "./AppendixLiquid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2690ab9b",
  null
  
)

export default component.exports